module.exports = __webpack_public_path__ + "static/img/sys-3.b6bda35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sys-3.png
// module id = dAxp
// module chunks = 1